import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useUser } from "../Contexts/UserContext";
import { useModal } from "../Contexts/ModalContext";

const Timeout = () => {
    const navigate = useNavigate();
    const navigateHome = () => navigate("/home");

    const {user, closeUserSession} = useUser();

    const {showModal} = useModal();

    const [isModalOpen, setIsModalOpen] = useState(false);

    let inactivityTimeout;
    const intervalRef = useRef(null);

    // Increment the inactivity counter every few seconds
    let inactiveCounter = 0;

    const timeout = 1; // Timeout in minutes
    const inactivityLimit = 60000 * timeout; // 1 minute (in milliseconds) // Timeout
    const inactivityCheckInterval = 2000; // Every 2 seconds (in milliseconds)
    const inactivityCount = inactivityLimit / inactivityCheckInterval; 

    /**** Activity Tracking**************** */
    /*
    function resetInactivityTimer() {
        clearTimeout(inactivityTimeout); // Clear any existing timer
        inactivityTimeout = setTimeout(() => {
        console.log("User is inactive 1.");
        // Here you could log out the user, show a modal, etc.
        }, inactivityLimit);
    }
    */
    function activityDetected() {
        inactiveCounter = 0; // Reset the counter on activity
        //resetInactivityTimer();
    }

    function resetTimer() {
        if(intervalRef.current) {
            clearInterval(intervalRef.current); // Clear existing timer
            console.log("INFO: Timer Reset.");
        }
        inactiveCounter = 0;
    }

    function startUserSession() {
        resetTimer();

        intervalRef.current = setInterval(() => {
            inactiveCounter++;
            if (inactiveCounter >= inactivityCount) {
                console.log("INFO: User is inactive. Logging out");
                logout();
            }
        }, inactivityCheckInterval);
        console.log('INFO: Starting Timer for user activity');
    }

    function stopUserSession() {
        console.log("INFO: Removing Timer for user activity.");
        resetTimer();
    }

    function userStateChanged() {
        if(user == null) {
            stopUserSession();
        }
        else {
            startUserSession();
        }
    }

    function logout() {
        navigate("/logout");
    }

    // Listen for user activities to reset the inactivity timer
    window.addEventListener("mousemove", activityDetected);
    window.addEventListener("keydown", activityDetected);
    window.addEventListener("scroll", activityDetected);
    window.addEventListener("click", activityDetected);

    // Initialize the timer when the page loads
    // resetInactivityTimer();

    // document.hidden - User is inactive (page gets hidden)
    // ! document.hidden - User is active (page gets visible)
    document.addEventListener("visibilitychange", activityDetected);
    // document.hasFocus() - User is avtive (window is focsed)
    window.addEventListener("focus", activityDetected);
    // ! document.hasFocus() - User is inactive (window unfocused)
    window.addEventListener("blur", activityDetected);
  
    useEffect(() => {
        userStateChanged(); // Call the method when `user` state changes
      }, [user]); // This will re-run every time `user` changes
      
    return ( null ); // No UI Rendered
};

export default Timeout;
